import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import {
  locationReceiptSettingsGetCustomerBillSettings,
  locationsGetById,
} from "~/api-refs";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

import { CustomerBillReceiptSettingsForm } from "../../../../../components/receipts/customer-bill-form";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/receipts/customer-bill"
)({
  component: CustomerBillReceiptSettingsPage,
});

function CustomerBillReceiptSettingsPage() {
  const { id } = Route.useParams();

  const { data: settings, isPending: settingsLoading } = useQuery(
    convexQuery(locationReceiptSettingsGetCustomerBillSettings, {
      locationId: toConvexTableId("locations", id),
    })
  );
  const { data: location, isPending: locationLoading } = useQuery(
    convexQuery(locationsGetById, {
      id: toConvexTableId("locations", id),
    })
  );

  if (settingsLoading || locationLoading) {
    return <LoadingPanel message="Loading settings..." />;
  }

  if (!location) {
    throw new Error("Location not found");
  }

  return (
    <CustomerBillReceiptSettingsForm
      location={location}
      settings={
        settings
          ? {
              ...settings,
              printerId: settings.printerId ?? null,
              customText: settings.customText ?? null,
            }
          : null
      }
    />
  );
}
